'use strict';

import * as angular from 'angular';
import '../base/index';
import './nocRoutes';
import './noc-services';

var app = angular.module('noc.core', [
    'noc.base',
    'noc.routes', 
    'noc.services'
]);

app.factory('LocaleFactory', require('./localeFactory'));
app.factory('NocHttpInterceptor', require('./nocHttpInterceptor'));
app.factory('StateManagerFactory', require('./stateManagerFactory'));
app.factory('TimeZoneFactory', require('./timezoneFactory'));
app.factory('FilterStorage', require('./filterStorage'));

app.service('XSRFInterceptor', require('./xsrfInterceptor'));
app.service('ApiTokenManagement', require('./apiTokenManagement'));

export default app;